import '@/common/App.css';

import { Lobby } from '@/controller/routes/Lobby';

import {
  ControllerAppModel,
  controllerAppModelContext,
  ScreenState,
} from './models/ControllerAppModel';
import { EnterCode } from './routes/EnterCode';
import { EnterName } from './routes/EnterName';
import { GamePlayerPage } from './routes/GamePlayerPage';

import { Toast } from '@/common/components/base/Toast';
import * as RadixToast from '@radix-ui/react-toast';
import { observer, Observer } from 'mobx-react-lite';
import { useEffect, useState } from 'react';
import { firebasePersistencePromise } from '@/common/firebase';
import { setupAutoScreenLock } from '@/common/utils/browser';
import { InactiveDialog } from './components/dialogs/InactiveDialog';
import { flex1, FlexColumn, fullSize, fullWidth, relative } from '@toilet-paper-games/ui';
import { ControllerTopBar } from './components/ControllerTopBar';
import { SettingsDialog } from './components/dialogs/SettingsDialog';
import { MenuDialog } from './components/dialogs/MenuDialog';
import { PlayersDialog } from './components/dialogs/PlayersDialog';
import { KickedDialog } from './components/dialogs/KickedDialog';

setupAutoScreenLock();

export const controllerAppModel = new ControllerAppModel();
window.controllerAppModel = controllerAppModel;

export const App = () => {
  const [loading, setLoading] = useState(true);
  if (!window.controllerAppModel) {
    window.controllerAppModel = controllerAppModel;
  }

  useEffect(() => {
    firebasePersistencePromise.then(() => {
      setLoading(false);
    });
  });

  // TODO: Add a common loading spinner
  if (loading) {
    // return 'Loading...';
    return null;
  }

  return (
    <controllerAppModelContext.Provider value={window.controllerAppModel}>
      <RadixToast.Provider>
        <FlexColumn css={[fullSize]}>
          <Observer>
            {() => (
              <>
                {controllerAppModel.networkHandler.hasHostConnection &&
                  controllerAppModel.networkHandler.networkReady && <ControllerTopBar />}
              </>
            )}
          </Observer>
          <div css={[fullWidth, flex1, relative()]}>
            <ScreenDisplay />
          </div>
        </FlexColumn>
        <Dialogs />
        <Observer>
          {() => (
            <>
              {controllerAppModel.toastManager.toasts.map((toastData) => (
                <Toast key={toastData.id} {...toastData.toast} />
              ))}
            </>
          )}
        </Observer>
        <RadixToast.Viewport
          css={{
            '--viewport-padding': '25px',
            position: 'fixed',
            bottom: '0',
            right: '0',
            display: 'flex',
            flexDirection: 'column',
            padding: 'var(--viewport-padding)',
            gap: '10px',
            width: '390px',
            maxWidth: '100vw',
            margin: '0',
            listStyle: 'none',
            zIndex: 2147483647,
            outline: 'none',
          }}
        />
      </RadixToast.Provider>
    </controllerAppModelContext.Provider>
  );
};

export const ScreenDisplay = observer(() => {
  const appStore = controllerAppModel;

  if (
    !appStore.networkHandler.hasHostConnection ||
    !appStore.networkHandler.networkReady
  ) {
    return <EnterCode />;
  }

  const screenState = appStore.screenState;

  switch (screenState) {
    // case ScreenState.LOADING:
    //   return <LoadingGame loading />;
    case ScreenState.LOBBY:
      return <Lobby />;
    case ScreenState.GAME:
      return <GamePlayerPage />;
    default:
      return <div>Unknown screen state</div>;
  }
});

export const Dialogs = observer(() => {
  const appStore = controllerAppModel;

  if (
    !appStore.networkHandler.hasHostConnection ||
    !appStore.networkHandler.networkReady
  ) {
    return null;
  }

  return [
    <EnterName />,
    <SettingsDialog />,
    <MenuDialog />,
    <PlayersDialog />,
    <InactiveDialog />,
    <KickedDialog />,
  ];
});
